// Thin fetch wrapper around the Tyrael FastAPI. Same-origin in production
// (nginx proxies /api/* to the FastAPI on 127.0.0.1:8000), so no CORS to
// configure and no auth headers to forward — that becomes session-cookie
// once we wire up real auth.
const API_BASE = "/api";

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, body: unknown, message: string) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  const r = await fetch(`${API_BASE}${path}`, {
    method: "GET",
    signal,
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  });
  if (!r.ok) {
    const body = await r.text().catch(() => "");
    throw new ApiError(r.status, body, `GET ${path} failed: ${r.status}`);
  }
  return r.json() as Promise<T>;
}

export async function apiPost<T, B = unknown>(
  path: string,
  body: B,
  signal?: AbortSignal,
): Promise<T> {
  const r = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    signal,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: "same-origin",
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    const text = await r.text().catch(() => "");
    throw new ApiError(r.status, text, `POST ${path} failed: ${r.status}`);
  }
  return r.json() as Promise<T>;
}
